import { ButtonLinkTypeEnum } from 'common/enums/ButtonLinkEnum'
import React from 'react'
import { ButtonUiInterface } from './button-ui.schema'
import { ButtonContentUi } from './ui/button-content-ui'
import { ButtonIconUi } from './ui/button-icon-ui'
import { LinkButtonUi } from './ui/link-button-ui'
import { SubTextUiNew } from './ui/sub-text-ui'

export interface LinkButtonProps extends ButtonUiInterface {
  attrId: string
  dataTestId?: string
  disabled?: boolean
  onClick?: () => void
  target?: ButtonLinkTypeEnum | '_parent'
  href: string
  rel?: string
}

export const LinkButton = ({
  dataTestId,
  attrId,
  text,
  subText,
  padding,
  mobilePadding,
  alignSelf,
  mobileAlignSelf,
  width,
  mobileWidth,
  textFontSize,
  mobileTextFontSize,
  subTextFontSize,
  mobileSubTextFontSize,
  textFontFamily,
  textFontWeight,
  textFontStyle,
  subTextFontFamily,
  subTextFontWeight,
  subTextFontStyle,
  mobileTextFontFamily,
  mobileTextFontWeight,
  mobileTextFontStyle,
  mobileSubTextFontFamily,
  mobileSubTextFontWeight,
  mobileSubTextFontStyle,
  textColor,
  subTextColor,
  mobileTextColor,
  mobileSubTextColor,
  background,
  mobileBackground,
  backgroundColor,
  mobileBackgroundColor,
  iconClassNameBefore,
  iconClassNameAfter,
  border,
  mobileBorder,
  boxShadow,
  mobileBoxShadow,
  lineHeight,
  mobileLineHeight,
  target,
  rel,
  href,
  hover,
  mobileHover,
}: LinkButtonProps) => {
  let linkRel = rel

  if (!linkRel && target === ButtonLinkTypeEnum.openInNewWindow) {
    linkRel = 'noopener noreferrer'
  }

  return (
    <LinkButtonUi
      data-test-ui={dataTestId}
      id={attrId}
      target={target}
      rel={linkRel}
      href={href}
      border={border}
      mobileBorder={mobileBorder}
      color={textColor}
      fontFamily={textFontFamily}
      fontWeight={textFontWeight}
      fontStyle={textFontStyle}
      fontSize={textFontSize}
      mobileFontSize={mobileTextFontSize}
      mobileColor={mobileTextColor}
      mobileFontFamily={mobileTextFontFamily}
      mobileFontWeight={mobileTextFontWeight}
      mobileFontStyle={mobileTextFontStyle}
      background={background ?? backgroundColor}
      mobileBackground={mobileBackground ?? mobileBackgroundColor}
      padding={padding}
      mobilePadding={mobilePadding}
      width={width}
      mobileWidth={mobileWidth}
      alignSelf={alignSelf}
      mobileAlignSelf={mobileAlignSelf}
      boxShadow={boxShadow}
      mobileBoxShadow={mobileBoxShadow}
      lineHeight={lineHeight}
      mobileLineHeight={mobileLineHeight}
      hover={hover}
      mobileHover={mobileHover}
    >
      <ButtonContentUi>
        {iconClassNameBefore && (
          <ButtonIconUi className={iconClassNameBefore} placed={'left'} />
        )}
        {text}
        {iconClassNameAfter && (
          <ButtonIconUi className={iconClassNameAfter} placed={'right'} />
        )}
      </ButtonContentUi>
      {subText && (
        <SubTextUiNew
          color={subTextColor}
          fontFamily={subTextFontFamily}
          fontWeight={subTextFontWeight}
          fontStyle={subTextFontStyle}
          fontSize={subTextFontSize}
          mobileFontSize={mobileSubTextFontSize}
          mobileColor={mobileSubTextColor}
          mobileFontFamily={mobileSubTextFontFamily}
          mobileFontWeight={mobileSubTextFontWeight}
          mobileFontStyle={mobileSubTextFontStyle}
        >
          {subText}
        </SubTextUiNew>
      )}
    </LinkButtonUi>
  )
}
